import { canUseDOM } from './dom';


export default !canUseDOM ? false : (('ontouchstart' in global)
  || ('ontouchstart' in document.documentElement)
  || (global.DocumentTouch && document instanceof global.DocumentTouch))
  || window.navigator.msMaxTouchPoints || false;
